import { COOKIE_KEYS } from 'js/src/libs/consts';
import QueryStringManipulator from 'js/src/libs/querystring-manipulator';

import Cookies from 'js-cookie';

export const LAST_UPSELL_QS_KEY = 'last_upsell';

const EXPIRY_DAYS = 30;
const MAX_SLUG_LENGTH = 64;

export const slugifyUpsellContext = (context: string): string =>
    context
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '_')
        .slice(0, MAX_SLUG_LENGTH)
        .replace(/^_+|_+$/g, '');

export const recordLastUpsell = (context: string): void => {
    const slug = slugifyUpsellContext(context);
    if (!slug) return;
    Cookies.set(COOKIE_KEYS.LAST_UPSELL, slug, { expires: EXPIRY_DAYS });
};

export const getLastUpsell = (): string | undefined => {
    const stored = Cookies.get(COOKIE_KEYS.LAST_UPSELL);
    if (!stored) return undefined;
    return slugifyUpsellContext(stored) || undefined;
};

export const clearLastUpsell = (): void => {
    Cookies.remove(COOKIE_KEYS.LAST_UPSELL);
};

export const withLastUpsellParam = (path: string): string => {
    const lastUpsell = getLastUpsell();
    if (!lastUpsell) return path;
    return QueryStringManipulator.updateQueryStringParameter(path, LAST_UPSELL_QS_KEY, lastUpsell);
};
